import APIURL from "../axios";
import { useQuery } from "react-query";

const Maintenance = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/maintenances`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowMaintenance = (uuid, lang) => {
  return useQuery(`show_maintenance-${lang}`, () => Maintenance(uuid, lang));
};

const Maintenances = async (uuid, e_uuid, lang) => {
  return await APIURL.get(`/${uuid}/maintenance/${e_uuid}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowMaintenances = (uuid, e_uuid, lang) => {
  return useQuery(`maintenances-${lang}-${e_uuid}`, () =>
    Maintenances(uuid, e_uuid, lang),
  );
};
